import * as React from 'react';
import Svg, {Path} from 'react-native-svg';

function SmallDownIcon() {
  return (
    <Svg width={16} height={10} viewBox="0 0 16 10" fill="none">
      <Path d="M1 1.5l7 7 7-7" stroke="#2E2EAB" strokeOpacity={0.9} strokeWidth={1.75} />
    </Svg>
  );
}

export default SmallDownIcon;
